import {
    FETCH_MEDICLAIM_INVOICELIST_REQUEST,
    FETCH_MEDICLAIM_INVOICELIST_SUCCESS,
    FETCH_MEDICLAIM_INVOICELIST_FAILURE,
  } from "./FetchMediclaimListingTypes";
  
  const initialState = {
    loading: false,
    mediclaimInvoiceList: [],
    error: "",
  };
  
  const reducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_MEDICLAIM_INVOICELIST_REQUEST:
        return {
          ...state,
          loading: true,
        };
      case FETCH_MEDICLAIM_INVOICELIST_SUCCESS:
        return {
          loading: false,
          mediclaimInvoiceList: action.payload,
          error: "",
        };
      case FETCH_MEDICLAIM_INVOICELIST_FAILURE:
        return {
          loading: false,
          mediclaimInvoiceList: [],
          error: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default reducer;
  